import { useContext } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { motion } from "framer-motion";
import { ToastContainer } from "react-toastify";
import MainPage from "./components/MainPage";
import Header from "./components/Header";
import { CursorContext } from "./context/CursorContext";
import Blog from "./pages/Blog";
import "react-toastify/dist/ReactToastify.css";
import CstmNotFound from "./pages/CstmNotFound.js";
import DietPlan from "./pages/DietPlan.jsx";
import Workout from "./pages/Workout.jsx";

const App = () => {
  const { cursorVariants, cursorBG } = useContext(CursorContext);

  return (
    <>
      <Router>
        <Routes>
          {/* 🧩 Main homepage route */}
          <Route path="/" element={<MainPage />} />

          {/* 🧩 Blog route with Header + Footer layout */}
          <Route
            path="/blog"
            element={
              <>
                <Header />
                <Blog />
              </>
            }
          />
          {/* 🧩 Diet Plan route with Header + Footer layout */}
          <Route
            path="/diet"
            element={
              <>
                <Header />
                <DietPlan />
              </>
            }
          />
          {/* 🧩 Diet Plan route with Header + Footer layout */}
          <Route
            path="/workout"
            element={
              <>
                <Header />
                <Workout />
              </>
            }
          />
          {/* 🧩 Catch-all route for 404 page */}
          <Route
            path="/*"
            element={
              <>
                <Header />
                <CstmNotFound />
              </>
            }
          />
        </Routes>
      </Router>
      {/* 🧩 Toast notification container (top-right) */}
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="dark"
      />

      {/* 🧩 Custom animated cursor — purple glow variant */}
      <motion.div
        variants={cursorVariants}
        animate={cursorBG}
        transition={{ type: "spring", stiffness: 500, damping: 30 }}
        className="fixed top-0 left-0 pointer-events-none z-50 rounded-full"
        style={{ width: "32px", height: "32px" }}
      />
    </>
  );
};

export default App;
